/**
 * Generated runtime TestId mirror for frontend/src/pages/CertificationReviews.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const CertificationReviewsTestIds = {
  btnBulkCertify: "btn-bulk-certify",
  btnCertifyItem: "btn-certify-item",
  btnReassignItem: "btn-reassign-item",
  btnReviewAssignments: "btn-review-assignments",
  campaignQuickFilter: "campaign-quick-filter",
  colDecidedAssignments: "col-decided-assignments",
  colExpand: "col-expand",
  colIdentity: "col-identity",
  colStatus: "col-status",
  reviewDetailCampaign: "review-detail-campaign",
  reviewDetailName: "review-detail-name",
  reviewDetailReviewer: "review-detail-reviewer",
  reviewItemsCount: "review-items-count",
  reviewLeftPanel: "review-left-panel",
  reviewMasterDetail: "review-master-detail",
  reviewProgress: "review-progress",
  reviewRightPanel: "review-right-panel",
  statDecided: "stat-decided",
  campaignFilter: (campaign_id: string) => `campaign-filter-${campaign_id}`,
  campaignFilterPrefix: () => "campaign-filter-" as TestIdPrefix,
  reviewItem: (item_id: string) => `review-item-${item_id}`,
  reviewItemPrefix: () => "review-item-" as TestIdPrefix,
  reviewItemCheckbox: (item_id: string) => `review-item-checkbox-${item_id}`,
  reviewItemCheckboxPrefix: () => "review-item-checkbox-" as TestIdPrefix,
  reviewItemName: (item_id: string) => `review-item-name-${item_id}`,
  reviewItemNamePrefix: () => "review-item-name-" as TestIdPrefix,
  reviewItemSelfCert: (item_id: string) => `review-item-self-cert-${item_id}`,
  reviewItemSelfCertPrefix: () => "review-item-self-cert-" as TestIdPrefix,
  reviewItemStatus: (item_id: string) => `review-item-status-${item_id}`,
  reviewItemStatusPrefix: () => "review-item-status-" as TestIdPrefix
} as const;
